var map = {
	"./CBA_menuData.js": "9a9f",
	"./FBLCSL_menuData.js": "4423",
	"./FIBAManAsiaCup_menuData.js": "bb42",
	"./FIBAWomenAsiaCup_menuData.js": "141a",
	"./FIFAWorldCup_menuData.js": "ce57",
	"./HengqinMara_menuData.js": "6925",
	"./WCQAsianZone_menuData.js": "bcce",
	"./asianGames_menuData.js": "1c43",
	"./asianWinterGames_menuData.js": "a54d",
	"./milanWinterGames_menuData.js": "bb79",
	"./nationalGames_menuData.js": "31bc",
	"./olympicGames_menuData.js": "d47b",
	"./sudirman_menuData.js": "351f",
	"./tennisChinaOpen_menuData.js": "c8af",
	"./thomasAndUber_menuData.js": "87cf",
	"./universiades_menuData.js": "372e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";